export const envConfig = {
  vapi: {
    apiUrl: process.env.REACT_APP_VAPI_API_URL ?? "https://api.vapi.ai",
    token: process.env.REACT_APP_VAPI_WEB_TOKEN ?? "055d3a62-a2c1-4908-967b-2d88ad5476e1",
    assistant_token: process.env.REACT_APP_VAPI_ASSISTANT_TOKEN ?? "0944609a-2ced-4313-9f59-e5fc5b4b1576",
    api_key: process.env.REACT_APP_VAPI_API_KEY ?? "db391668-3002-4ae3-a20b-8d9476620ceb",
    assistant_id: process.env.REACT_APP_VAPI_ASSISTANT_ID ?? "b3cb5e8f-6c59-42bf-ab28-9fa1ce08e403",
  },
};
